<template>
  <div class="page-con">
    <div class="list-box clearfix" style="padding: 40px;">
      <vxe-form
          ref="xForm"
          class="my-form2"
          title-align="right"
          title-width="150"
          :data="formData"
          :rules="!isEdit ? formRules1 : formRules2"
          style="padding-right: 100px"
          prevent-submit>
        <!--        <vxe-form-item span="24">-->
        <!--          <template>-->
        <!--            <div class="block">-->
        <!--              <div class="block-tip"></div>-->
        <!--              <span class="block-title">管理员信息</span>-->
        <!--            </div>-->
        <!--          </template>-->
        <!--        </vxe-form-item>-->
        <!--        <vxe-form-item title="管理员类型" field="managerType" span="8">-->
        <!--          <template>-->
        <!--            <div v-if="!isEdit">{{formData.managerType | managerType}}</div>-->
        <!--            <vxe-select-->
        <!--                style="width: 300px;"-->
        <!--                v-else-->
        <!--                v-model="formData.managerType"-->
        <!--                placeholder="请选择管理员类型"-->
        <!--                :options="managerType"-->
        <!--                transfer-->
        <!--            ></vxe-select>-->
        <!--          </template>-->
        <!--        </vxe-form-item>-->
        <!--        <vxe-form-item title="真实姓名" field="managerName" span="8">-->
        <!--          <template v-slot="scope">-->
        <!--            <div v-if="!isEdit">{{formData.managerName}}</div>-->
        <!--            <vxe-input v-else v-model="formData.managerName" placeholder="请输入管理员姓名" clearable-->
        <!--                       @input="$refs.xForm.updateStatus(scope)" style="width: 300px;"></vxe-input>-->
        <!--          </template>-->
        <!--        </vxe-form-item>-->
        <!--        <vxe-form-item title="身份证号码" field="idcardNum" span="8">-->
        <!--          <template v-slot="scope">-->
        <!--            <div v-if="!isEdit">{{formData.idcardNum}}</div>-->
        <!--            <vxe-input v-else v-model="formData.idcardNum" type="number" placeholder="请输入管理员身份证号码" clearable-->
        <!--                       @input="$refs.xForm.updateStatus(scope)" style="width: 300px;"></vxe-input>-->
        <!--          </template>-->
        <!--        </vxe-form-item>-->
        <!--        <vxe-form-item title="手机号" field="managerPhone" span="8">-->
        <!--          <template v-slot="scope">-->
        <!--            <div v-if="!isEdit">{{formData.managerPhone}}</div>-->
        <!--            <vxe-input v-else v-model="formData.managerPhone" type="number" placeholder="请输入管理员手机号" clearable-->
        <!--                       @input="$refs.xForm.updateStatus(scope)" style="width: 300px;"></vxe-input>-->
        <!--          </template>-->
        <!--        </vxe-form-item>-->
        <!--        <vxe-form-item title="身份证正面照" field="idcardFrontUrl" span="8">-->
        <!--          <template>-->
        <!--            <upload-img :readOnly="!isEdit" :row="formData" :fileKey="'idcardFrontUrl'" :width="100" :height="100"-->
        <!--                        :initFile="formData.idcardFrontUrl"></upload-img>-->
        <!--          </template>-->
        <!--        </vxe-form-item>-->
        <!--        <vxe-form-item title="身份证反面照" field="idcardBackUrl" span="8">-->
        <!--          <template>-->
        <!--            <upload-img :readOnly="!isEdit" :row="formData" :fileKey="'idcardBackUrl'" :width="100" :height="100"-->
        <!--                        :initFile="formData.idcardBackUrl"></upload-img>-->
        <!--          </template>-->
        <!--        </vxe-form-item>-->
        <vxe-form-item span="24">
          <template>
            <div class="block">
              <div class="block-tip"></div>
              <span class="block-title">企业信息</span>
            </div>
          </template>
        </vxe-form-item>
        <vxe-form-item title="企业名称" field="compName" span="24">
          <template v-slot="scope">
            <div v-if="!isEdit">{{formData.compName}}</div>
            <vxe-input v-else v-model="formData.compName" placeholder="请输入企业名称" clearable
                       @input="$refs.xForm.updateStatus(scope)" style="width: 300px;"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="统一社会信用代码" field="taxNum" span="24">
          <template v-slot="scope">
            <div v-if="!isEdit">{{formData.taxNum}}</div>
            <vxe-input v-else v-model="formData.taxNum" placeholder="请输入统一社会信用代码" clearable
                       @input="$refs.xForm.updateStatus(scope)" style="width: 300px;"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="法人姓名" field="realName" span="24">
          <template v-slot="scope">
            <div v-if="!isEdit">{{formData.realName}}</div>
            <vxe-input v-else v-model="formData.realName" placeholder="请输入法人姓名" clearable
                       @input="$refs.xForm.updateStatus(scope)" style="width: 300px;"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="营业执照" field="businessUrl" span="24">
          <template>
            <upload-img :readOnly="!isEdit" :row="formData" :fileKey="'businessUrl'" :width="100" :height="100"
                        :initFile="formData.businessUrl"></upload-img>
          </template>
        </vxe-form-item>
        <vxe-form-item span="24" v-if="formData.userCategory === 4">
          <template>
            <div class="block">
              <div class="block-tip"></div>
              <span class="block-title">道路运输经营许可证信息</span>
            </div>
          </template>
        </vxe-form-item>
        <vxe-form-item title="经营许可证号" field="businessLicenseNum" span="24" v-if="formData.userCategory === 4">
          <template v-slot="scope">
            <div v-if="!isEdit">{{formData.businessLicenseNum}}</div>
            <vxe-input v-else v-model="formData.businessLicenseNum" placeholder="请输入经营许可证号"
                       @input="$refs.xForm.updateStatus(scope)" style="width: 300px;"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="有效期至" field="businessExpireTime" span="24" v-if="formData.userCategory === 4">
          <span v-if="!isEdit">{{formData.businessExpireTime | timeFormatDate}}</span>
          <vxe-input v-else class="formInput" type="date" v-model="formData.businessExpireTime"
                     placeholder="请选择日期" style="width: 300px;"></vxe-input>
        </vxe-form-item>
        <vxe-form-item span="8" v-if="formData.userCategory === 4"></vxe-form-item>
        <vxe-form-item title="经营许可证" field="transportLicenseUrl" span="24" v-if="formData.userCategory === 4">
          <template>
            <upload-img :readOnly="!isEdit" :row="formData" :fileKey="'transportLicenseUrl'" :width="100" :height="100"
                        :initFile="formData.transportLicenseUrl"></upload-img>
          </template>
        </vxe-form-item>
        <vxe-form-item title="" v-if="audit_status === 1" field="auditStatus" span="24">
          <template>
            <vxe-radio-group v-model="formData.auditStatus" style="margin-left: 60px;">
              <vxe-radio :label="3" content="审核通过"></vxe-radio>
              <vxe-radio :label="2" content="驳回修改"></vxe-radio>
            </vxe-radio-group>
          </template>
        </vxe-form-item>
        <vxe-form-item v-if="audit_status === 1 && formData.auditStatus === 2" title="审核意见："
                       field="remark" span="24">
          <template>
            <vxe-textarea v-model="formData.remark" style="width: 300px" size="medium"></vxe-textarea>
          </template>
        </vxe-form-item>
        <vxe-form-item align="center" span="24" v-if="audit_status === 2">
          <template v-slot>
            <div style="margin-left:200px;color: #f10404;display: flex;align-items: center;">
              <img style="width: 20px;height: 20px;" src="@/assets/images/common/warnInfo.png"/>
              <span style="margin-left: 10px;">{{errMsg}}</span>
            </div>
          </template>
        </vxe-form-item>
        <vxe-form-item v-if="audit_status === 3" title="审核意见："
                       field="remark" span="24">
          <template>
            <vxe-textarea v-model="formData.remark" style="width: 300px" size="medium"></vxe-textarea>
          </template>
        </vxe-form-item>
        <vxe-form-item align="center" span="24">
          <template v-slot>
            <vxe-button type="submit" status="primary" v-if="audit_status === 1" @click="updateCompanyAuth">提交
            </vxe-button>
            <vxe-button type="submit" status="primary" v-if="audit_status === 3" @click="cancelAuth">取消认证</vxe-button>
            <vxe-button type="submit" status="primary" v-if="audit_status === 2 || audit_status === 4" @click="close">关
              闭
            </vxe-button>
          </template>
        </vxe-form-item>
      </vxe-form>
    </div>
  </div>
</template>
<script>
  import auth from "@/utils/auth";
  import {showLoading, hideLoading} from "@/utils/util";
  import $api from "@/apiProvider";
  import getAuthOrization from "@/mixin/getAuthOrization";
  import Auth from "@/utils/auth.js";
  import Viewer from "v-viewer";
  import "viewerjs/dist/viewer.css";
  import UploadImg from "@/components/common/UploadImg";
  import Vue from "vue";

  Vue.use(Viewer);

  export default {
    name: 'compAuthentication',
    mixins: [getAuthOrization],
    components: {UploadImg},
    data() {
      let userInfoValue = {};
      if (Auth.isLogin()) {
        userInfoValue = Auth.getAuth();
      }
      return {
        userInfoValue,
        errMsg: '',
        formData: {
          auditStatus: 3,//审核radio
          businessUrl: null,
          compName: null,
          idcardBackUrl: null,
          idcardFrontUrl: null,
          transportLicenseUrl: null,
          idcardNum: null,
          realName: null,
          taxNum: null,
          remark: null,
          userCategory: null,
          businessLicenseNum: null,
          businessExpireTime: null,
          managerType: null,
          managerName: null,
          managerPhone: null
        },
        formRules1: {
          remark: [
            {required: true, message: "请输入审核意见", trigger: "blur",},
          ],
        },
        formRules2: {
          remark: [
            {required: true, message: "请输入审核意见", trigger: "blur",},
          ],
          taxNum: [
            {required: true, message: "请输入统一社会信用代码", trigger: "blur"},
            {min: 18, max: 18, message: "请输入正确的统一社会信用代码"},
          ],
          idcardNum: [
            {required: true, message: "请输入身份证号码", trigger: "blur",},
            {min: 18, max: 18, message: "请输入正确的身份证号码"},
          ],
          businessLicenseNum: [
            {required: true, message: "请输入经营许可证", trigger: "blur",},
          ],
          businessExpireTime: [
            {required: true, message: "请选择日期", trigger: "blur",},
          ],
          transportLicenseUrl: [
            {required: true, message: "请上传经营许可证", trigger: "blur",},
          ],
        },
        managerType: [
          {
            label: '法定代表人',
            value: 1,
          }, {
            label: '非法定代表人',
            value: 2,
          }
        ],
        userId: '',
        isEdit: false,
        audit_status: 1 //认证状态1.已提交/待审核 2.未通过 3.通过 4.已过期
      }
    },
    filters: {
      managerType(val) {
        if (val != null) {
          if (val === 1) {
            return "法定代表人";
          }
          if (val === 2) {
            return "非法定代表人";
          }
        }
      },
    },
    methods: {
      init(id) {
        this.userId = id;
        this.queryUserAuth();
      },
      reset() {
        this.formData = {
          auditStatus: 3,//审核radio
          businessUrl: null,
          compName: null,
          idcardBackUrl: null,
          idcardFrontUrl: null,
          idcardNum: null,
          realName: null,
          taxNum: null,
          remark: null,
          userCategory: null,
          businessLicenseNum: null,
          businessExpireTime: null,
          managerType: null,
          managerName: null,
          managerPhone: null
        }
      },
      async validEvent() {
        const errMap = await this.$refs.xForm
          .validate()
          .catch((errMap) => errMap);
        return errMap ? false : true;
      },
      async auditAuth() {
        let sts = await this.validEvent();
        if (sts) {
          showLoading();
          let param = {
            userId: parseInt(this.userId),
            auditStatus: this.formData.auditStatus,
            auditUserId: parseInt(this.userInfoValue.id),
          }
          if (this.formData.remark) {
            param.remark = this.formData.remark;
          }
          let res = await $api.authUser.request("auditAuth", param);
          hideLoading();
          if (res.status === 1) {
            this.$Message.success('提交成功');
            this.close();
          } else {
            this.$XModal.alert({
              message: res.message ? res.message : "接口异常",
              status: "error",
            });
          }
        }
      },
      async cancelAuth() {
        let sts = await this.validEvent();
        if (sts) {
          showLoading();
          let param = {
            userId: parseInt(this.userId),
            remark: this.formData.remark,
            userType: 1
          }
          let res = await $api.authUser.post("cancelAuth", param);
          hideLoading();
          if (res.status === 1) {
            this.$Message.success('取消成功');
            this.close();
          } else {
            this.$XModal.alert({
              message: res.message ? res.message : "接口异常",
              status: "error",
            });
          }
        }
      },
      async queryUserAuth() {
        showLoading();
        let res = await $api.authUser.request("queryUserAuth", {userId: this.userId});
        hideLoading();
        if (res.status === 1) {
          this.clearV();
          let data = Object.assign({}, res.data);
          this.audit_status = data.auditStatus;
          this.isEdit = this.audit_status === 1;
          this.formData.businessUrl = data.businessUrl
          this.formData.compName = data.compName;
          this.formData.idcardBackUrl = data.idcardBackUrl;
          this.formData.idcardFrontUrl = data.idcardFrontUrl;
          this.formData.transportLicenseUrl = data.transportLicenseUrl;
          this.formData.idcardNum = data.idcardNum;
          this.formData.realName = data.realName;
          this.formData.taxNum = data.taxNum;
          this.formData.businessLicenseNum = data.businessLicenseNum;
          this.formData.userCategory = data.userCategory;
          // this.formData.businessExpireTime = data.businessExpireTime;
          if (data.businessExpireTime) {
            this.formData.businessExpireTime = this.$utils.toDateString(data.businessExpireTime, "yyyy-MM-dd");
          }
          if (data.remark) {
            this.formData.remark = data.remark;
          }
          this.formData.managerType = data.managerType;
          this.formData.managerName = data.managerName;
          this.formData.managerPhone = data.managerPhone;
          if (this.audit_status === 2) {
            let authSource = '';
            let err = '未知';
            if (data.authSource === 1) {
              authSource = '平台'
              err = data.remark;
            } else if (data.authSource === 2) {
              authSource = '法大大'
              err = data.statusDesc;
            }
            this.errMsg = '未通过原因(' + authSource + '):' + err;
          } else {
            this.errMsg = '';
          }
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async updateCompanyAuth() {
        showLoading();
        let res = await $api.authUser.request("updateCompanyAuth", {
          idcardBackUrl: this.formData.idcardBackUrl,
          idcardFrontUrl: this.formData.idcardFrontUrl,
          transportLicenseUrl: this.formData.transportLicenseUrl,
          idcardNum: this.formData.idcardNum,
          businessUrl: this.formData.businessUrl,
          taxNum: this.formData.taxNum,
          compName: this.formData.compName,
          realName: this.formData.realName,
          businessLicenseNum: this.formData.businessLicenseNum,
          businessExpireTime: this.$utils.timestamp(this.formData.businessExpireTime),
          userId: this.userId,
          // managerType: this.formData.managerType,
          // managerName: this.formData.managerName,
          // managerPhone: this.formData.managerPhone,
          userType: 1,
        });
        hideLoading();
        if (res.status === 1) {
          this.auditAuth();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      close() {
        this.$emit('close');
      },
      clearV() {
        this.$refs.xForm.clearValidate();
      },
    }
  }
</script>
<style scoped>
  .picTitle {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .picTitle img {
    width: 140px;
    height: 100px;
    border: 1px dashed black
  }

  .picTitle span {
    font-size: 14px;
    margin-top: 8px;
  }

  .uploadPic {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .uploadPic .ivu-upload {
    width: 140px;
    height: 100px;
  }

  .upload-div {
    width: 140px;
    height: 100px;
    border: 1px dashed black;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .upload-img {
    width: 140px;
    height: 100px;
    /*border: 1px dashed black;*/
  }

  .upload-title {
    color: rgb(153, 153, 153);
    font-size: 14px;
    margin-top: 8px;
  }

  .remark {
    font-size: 14px;
    color: #CCCCCC;
    margin-top: 8px;
  }

  .block {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }

  .block-tip {
    width: 4px;
    height: 16px;
    background: #539FFF;
  }

  .block-title {
    margin-left: 4px;
    height: 21px;
    font-size: 16px;
    font-weight: bold;
    line-height: 21px;
    color: #539FFF;
  }
</style>
